<template>
  <v-dialog
    data-testid="validations-dialog-rejectValidationDialog"
    :value="show"
    :max-width="454"
    @click:outside="$emit('cancel')"
  >
    <v-card>
      <v-card-title class="h6 blue-grey--text text--darken-3">
        {{ $t('rev.validation.reject_validation_request') }}
      </v-card-title>
      <v-card-text>
        <p
          class="blue-grey--text text--darken-1 ma-0 pa-0 body-1 mb-4"
          v-html="$t('rev.validation.are_you_sure_you_want_to_reject')"
        />
        <CommentComposer
          hasCustomFooter
          :placeholder="$t('rev.validation.reject_validation_placeholder')"
          :validator="validator"
          @submit="handleSubmit"
          @cancel="handleCancel"
        >
          <template v-slot:footer="{ triggerSubmit, triggerCancel }">
            <div class="justify-end">
              <Button
                color="grey"
                plain
                data-testid="rejectValidationButton-button-cancel"
                :disabled="loading"
                :text="$t('common.button.cancel')"
                @click="triggerCancel"
              />
              <Button
                plain
                color="danger"
                data-testid="rejectValidationButton-button-confirmReject"
                :loading="loading"
                :disabled="loading"
                :text="$t('common.button.reject')"
                @click="triggerSubmit"
              />
            </div>
          </template>
        </CommentComposer>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import Button from '@/components/UI/Button'
import CommentComposer from '@/components/Core/Comments/CommentComposer'

export default {
  name: 'RejectValidationDialog',

  components: {
    Button,
    CommentComposer,
  },

  props: {
    loading: Boolean,
    show: Boolean,
  },

  data() {
    return {
      isValid: true,
    }
  },

  methods: {
    async handleSubmit(comment) {
      this.$emit('delete', comment)
    },

    handleCancel() {
      this.$emit('cancel')
    },

    validator(payload) {
      return Boolean(payload?.message?.trim())
    },
  },
}
</script>
